import { createFeatureSelector, createSelector } from "@ngrx/store";
import { IUtilitiesState } from "../../state/utilities.state";
import { IAppState } from "../../state/app.state";

export const getUtilitiesState = createFeatureSelector<IAppState, IUtilitiesState>('utilities');

export const getCountryList = createSelector(
    getUtilitiesState,
    (state: IUtilitiesState) => state.countries
);
export const getTaxRateSchedule = createSelector(
    getUtilitiesState,
    (state: IUtilitiesState) => state.taxRateSchedule
);
